import { createAction } from 'redux-starter-kit'
import { SET_SHUFFLED_OPTIONS } from '../constants/actions'

// actions
export const setShuffledOptions = createAction(SET_SHUFFLED_OPTIONS)
